import {
  IconButton,
  Grid,
  makeStyles,
  Container,
  Box,
  Badge,
  Button,
  TablePagination,
} from "@material-ui/core";
import SortRoundedIcon from "@material-ui/icons/SortRounded";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  Drawer,
  SimpleToolbar,
  Loader,
  TextField,
  Toast,
} from "../../../components";
import { useDrawer } from "../../../hooks";
import { AuthContext } from "../../../context";
import { useContext, useEffect, useRef, useState } from "react";
import { useZonesSelection } from "../../../hooks/useZoneSelection";
import { CustomMenu } from "../../../components/custom-menu";
import {
  UserListItem,
  ZoneAssignmentList,
} from "../../../components/zone-assignment-list";
import { laboratoryServices } from "../../../services";
import { useDebounce } from "../../../hooks/useDebounce";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { capitalizeFirstLetterArray } from "../../../helpers";
export default function AssigmentScreen() {
  const history = useHistory();
  const { authState, signOut } = useContext(AuthContext);
  const { isOpen, setIsOpen } = useDrawer();
  const { selectedZones, restoreZones } = useZonesSelection();

  // {doctors:[{_id:OID, zones:[_id,_id]}], representatives:[{_id:OID, zones:[_id,_id]}]
  const [assignmentsZones, setAssignmentsZones] = useState({
    doctors: [],
    representatives: [],
  });
  const [query, setQuery] = useState("");
  const debounceSearch = useDebounce(query, 500);
  const [filter, setFilter] = useState(["doctors", "representatives"]);
  const [loadingTable, setLoadingTable] = useState(false);
  const [dataZones, setDataZones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [users, setUsers] = useState([]);
  const classes = useStyles();
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);

  const isUserChecked = ({ type, _id }) => {
    const foundUser = assignmentsZones[type].find((user) => user._id === _id);
    return foundUser ? true : false;
  };
  const handleChangeQuery = (query) => {
    setQuery(query);
    // console.log(query);
  };
  const handleChangeFilter = (opt) => {
    if (opt === "all") setFilter(["doctors", "representatives"]);
    if (opt === "doctors") setFilter(["doctors"]);
    if (opt === "representatives") setFilter(["representatives"]);
  };
  const getUsers = async () => {
    try {
      setLoadingTable(true);
      const { status, response } =
        await laboratoryServices.getAssociatedUsersByLab({
          getOptions: {
            roles: filter,
            ascending: true,
            limit,
            page,
          },
          laboratoryId: authState.user.laboratory._id,
          token: authState.token,
        });
      // console.log(response.response);

      setLoadingTable(false);
      if (status === 200) {
        setUsers(response.response.data);
        setLimit(response.response.limit);
        setCount(response.response.total);
        setPage(response.response.page);
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      console.log(e);
    }
  };
  const handleAssignmentZonesToDoctor = async () => {
    if (
      !assignmentsZones.doctors.length &&
      !assignmentsZones.representatives.length
    ) {
      setToast(true);
      setToastMessage("Debe seleccionar al menos un usuario");
      return;
    }
    if (!selectedZones.length) {
      setToast(true);
      setToastMessage("Debe seleccionar al menos una zona a asignar");
      return;
    }
    try {
      setLoading(true);

      const { status, response } = await laboratoryServices.multizonification({
        multizonificationData: {
          laboratoryId: authState.user.laboratory._id,
          ...(assignmentsZones.doctors?.length > 0 && {
            doctors: assignmentsZones.doctors,
          }),

          ...(assignmentsZones.representatives?.length > 0 && {
            representatives: assignmentsZones.representatives,
          }),
        },
        token: authState.token,
      });
      setToast(true);
      setToastMessage(
        status !== 200 ? response.message : "Asignación completada"
      );
      if (status === 200) {
        setTimeout(() => {
          restoreZones();
          history.replace("/zones");
        }, 500);
      }
    } catch (e) {
      console.error("Error on Assignment Zone Screen", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUsers();
  }, [page, limit, filter]);

  // useEffect(() => {
  //   console.log({ selectedDoctors, selectedZones });
  // }, [selectedDoctors]);
  useEffect(() => {
    async function getDataZones() {
      laboratoryServices
        .getVisitingZones({
          laboratoryId: authState.user.laboratory._id,
          token: authState.token,
        })
        .then((res) => {
          if (res.status === 200) {
            const zones = res.response.response;
            setDataZones(zones.filter((z) => z.status === "active"));
          }
        })
        .catch((e) => console.error("Error on userListItem", e));
    }
    getDataZones();
  }, []);

  // dataToChange-->[{_id, zones}]
  // data --> {_id,zones}
  const addToArray = ({ dataToChange, data }) => {
    const foundData = dataToChange.find((prev) => prev._id === data._id);
    return foundData ? dataToChange : [...dataToChange, data];
  };

  const addToAssignments = (userType = "doctors", data) => {
    setAssignmentsZones((prev) => {
      const aux = { ...prev };
      let dataToChange = [];
      if (userType === "doctors") {
        dataToChange = prev.doctors;
      } else dataToChange = prev.representatives;

      aux[userType] = addToArray({ dataToChange, data });
      // console.log("addToAssignments", prev);

      return { ...aux };
    });
  };
  const deleteToAssignments = (userType = "doctors", data) => {
    setAssignmentsZones((prev) => {
      const aux = { ...prev };
      aux[userType] = prev[userType].filter((user) => user._id !== data._id);
      return { ...aux };
    });
  };

  const updateAssignments = (userType = "doctors", data) => {
    // console.log({ userType, data });

    setAssignmentsZones((prev) => {
      const aux = { ...prev };

      aux[userType] = prev[userType].map(({ _id, zones }) => {
        if (_id !== data._id) return { _id, zones };
        return { _id: data._id, zones: data.zones };
      });
      // console.log(prev);

      return { ...aux };
    });
  };
  const handleChangeSelectedUser = (checked, userType, data) => {
    if (checked) addToAssignments(userType, data);
    else deleteToAssignments(userType, data);
  };

  // useEffect(() => {
  //   console.log("data final", { assignmentsZones });
  // }, [assignmentsZones]);
  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.root}>
        {loading && <Loader loading={true} />}
        <Toast
          open={toast}
          message={toastMessage}
          close={() => setToast(false)}
        />
        <Grid item xs={12} className={classes.content}>
          <Container maxWidth={false}>
            <SimpleToolbar
              hideExport={authState.user.laboratory}
              isOpen={isOpen}
              setIsOpen={(value) => setIsOpen(value)}
              noSearchBar
            />
          </Container>

          <Container maxWidth={"md"} component={"main"}>
            <HeaderList
              query={query}
              onHandleQuery={handleChangeQuery}
              filter={filter}
              onHandleFilter={handleChangeFilter}
            />
            <Box
              className={classes.container_list_users}
              style={{ marginTop: 24 }}
            >
              {loadingTable ? (
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  style={{ marginTop: 24 }}
                >
                  <CircularProgress color="secondary" />
                </Box>
              ) : (
                <ZoneAssignmentList>
                  {users?.length > 0
                    ? users?.map((user) => {
                        const {
                          _id,
                          rut,
                          gender,
                          name,
                          lastName,
                          firstName,
                          userType,
                        } = user;
                        const fullName = `${
                          userType === "doctor" ? name : firstName
                        } ${lastName}`;
                        const disabledRepresentative =
                          userType !== "doctor" && user.status !== "active";
                        return (
                          <UserListItem
                            disabled={disabledRepresentative}
                            onHandleChange={handleChangeSelectedUser}
                            updateAssignments={updateAssignments}
                            key={_id}
                            id={_id}
                            userType={
                              userType === "doctor"
                                ? "doctors"
                                : "representatives"
                            }
                            primaryText={capitalizeFirstLetterArray(fullName)}
                            secondaryText={rut}
                            dataZones={dataZones}
                            userZones={user.zones || []}
                            checked={() =>
                              isUserChecked({
                                type:
                                  userType === "doctor"
                                    ? "doctors"
                                    : "representatives",
                                _id,
                              })
                            }
                          />
                        );
                      })
                    :  <Box className={classes.no_results}>
                  No hay registros que correspondan con su búsqueda.
                </Box>}
                </ZoneAssignmentList>
              )}
              <Box display="flex" justifyContent={"end"}>
                <TablePagination
                  labelRowsPerPage="Cant."
                  component="div"
                  count={count}
                  onRowsPerPageChange={(e) => setLimit(e.target.value)}
                  onPageChange={(e, page) => setPage(page + 1)}
                  page={page - 1}
                  rowsPerPage={limit}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                />
              </Box>
              <Box
                display={"flex"}
                justifyContent={"center"}
                style={{ marginTop: 16 }}
              >
                <Button
                  color="default"
                  variant="outlined"
                  onClick={() => history.goBack()}
                  style={{ margin: "0 16px", textTransform: "none" }}
                >
                  Cancelar
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  style={{ margin: "0 16px", textTransform: "none" }}
                  onClick={handleAssignmentZonesToDoctor}
                >
                  Asignar
                </Button>
              </Box>
            </Box>
          </Container>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 24,
    paddingBottom: 24,
    flex: 1,
    minHeight: "100vh",
  },
  content: {
    display: "flex",
    flexDirection: "column",
  },
    no_results: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(2),
    backgroundColor: `hsl(from ${theme.palette.primary.main} h s calc(l + 66))`,
    borderRadius: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

function HeaderList(props) {
  const classes = headerStyles();
  const { query, filter, onHandleQuery, onHandleFilter, loading } = props;
  const onEnterKeyPress = (e) => {
    const queryValue = e.target.value;
    if (e.charCode === 13) onHandleQuery(queryValue);
  };
  const handleQuery = (e) => {
    const queryValue = e.target.value;
    onHandleQuery(queryValue);
  };
  return (
    <Box className={classes.header_list} style={{ justifyContent: "end" }}>
      {/* <TextField
        disabled={loading}
        type={"text"}
        name={"query"}
        value={query}
        fullWidth
        placeholder={"Nombre del usuario..."}
        onKeyPress={onEnterKeyPress}
        style={{ justifyContent: "flex-end" }}
        iconComponent={() =>
          loading ? (
            <CircularProgress size={24} />
          ) : (
            <CloseRounded onClick={() => onHandleQuery("")} />
          )
        }
        onChange={handleQuery}
      /> */}
      <CustomMenu
        options={[
          { label: "Médicos", value: "doctors" },
          { label: "Representantes", value: "representatives" },
          { label: "Todos", value: "all" },
        ]}
        selectedOption={filter}
        onHandleSelectOption={(opt) => onHandleFilter(opt)}
      >
        <IconButton style={{ padding: "8px" }}>
          <Badge color="secondary" variant="dot" invisible={!filter}>
            <SortRoundedIcon />
          </Badge>
        </IconButton>
      </CustomMenu>
    </Box>
  );
}

const headerStyles = makeStyles((theme) => ({
  header_list: {
    marginTop: theme.spacing(2),
    display: "flex",
    "& .MuiInput-root": {
      "&.Mui-focused": {
        outlineOffset: `-1px `,
        outline: `1px solid ${theme.palette.warning.dark}`,
        border: "none",
      },
      "& input::placeholder": {
        color: theme.palette.grey[600],
      },
    },
  },
}));
